<template>
    <div class="base-mit-menu-footer">
      <v-list dense>
        <v-list-item v-if="userModel" @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Sign out</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!userModel" @click="login()">
          <v-list-item-icon>
            <v-icon>mdi-login</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Sign In</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
</template>

<script>

export default {
  name: 'BaseMitMenuHeader',
  components: {
  },
  props: {
    userModel: Object
  },
  methods : {
    logout() {
      this.$emit('logout');
    },
    login() {
      this.$emit('login');
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
